import { useAdmin } from '@/utils/hooks/useAdmin'
import { usePermissions } from '@/utils/hooks/usePermissions'
import { PERMISSIONS } from '@/utils/permissions'
import { type AbsenceComment } from '../types.graphql'
import { AbsenceCommentCardContent } from './absence-comment-card-content'
import { AbsenceCommentCardHeader } from './absence-comment-card-header'
import { cn } from '@/lib/utils'

interface Props {
  data: AbsenceComment
  editing: boolean
  onChangeEditing(editing: boolean): void
}

export function AbsenceCommentCard({ data, editing, onChangeEditing }: Props) {
  const { id, user, createdAt, content } = data

  const admin = useAdmin()
  const { hasPermissionsAndMe } = usePermissions()

  const canEdit =
    admin ||
    !!hasPermissionsAndMe(user, PERMISSIONS.timesheets.change.absencecomment)

  const canDelete =
    admin ||
    !!hasPermissionsAndMe(user, PERMISSIONS.timesheets.delete.absencecomment)
  const showMenu = canEdit || canDelete

  return (
    <article className={cn('overflow-hidden', editing ? 'bg-sky-50/40' : 'bg-white')}>
      <AbsenceCommentCardHeader
        id={id}
        user={user}
        createdAt={createdAt}
        showMenu={showMenu}
        canDelete={canDelete}
        canEdit={canEdit}
        editing={editing}
        onChangeEditing={onChangeEditing}
      />

      <AbsenceCommentCardContent
        id={id}
        content={content}
        editing={editing}
        onChangeEditing={onChangeEditing}
      />
    </article>
  )
}
